import React, { ReactNode } from 'react';
import { createGenericModalContext } from '../../BasicComponents/GenericModalContext';
import DetalheProcessoDialog from '../../DetalheProcessoDialog';

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheProcessoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <GenericModalProvider
            ModalComponent={DetalheProcessoDialog}
            urlParam="detalhe-processo"
        >
            {children}
        </GenericModalProvider>
    );
};

export const useModalDetalheProcesso = useGenericModal;